import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "../context/ThemeContext";

/**
 * Pins the html theme to `dark` while the visitor is on a public, marketing,
 * or sign-in route. The user's saved preference is restored as soon as they
 * land back on `/app/*` (or any authenticated route).
 *
 * Public routes (kept in sync with App.js):
 *   "/", "/pricing", "/privacy", "/support", "/terms", "/auth",
 *   "/b/:type/:tier" (public badge deeplink), "/u/:handle" (future profile)
 */
const PUBLIC_PREFIXES = ["/pricing", "/privacy", "/support", "/terms", "/auth", "/b/", "/u/"];

const isPublicPath = (p) => p === "/" || PUBLIC_PREFIXES.some((pref) => p.startsWith(pref));

export default function ThemeRouteSync() {
  const location = useLocation();
  const { setForcedDark } = useTheme();

  useEffect(() => {
    setForcedDark(isPublicPath(location.pathname));
  }, [location.pathname, setForcedDark]);

  return null;
}
